import React, { useState } from 'react';
import '../../../entrydoor.css';

const GlassDividersVerticalSideLiteEticom = ({ value, onChange, label = 'Vertical:', disabled = false }) => {
    const [selectedGlassDividersVerticalSideLiteEticom, setSelectedGlassDividersVerticalSideLiteEticom] = useState(value || "");
     const [GlassDividersVerticalSideLiteEticomError, setGlassDividersVerticalSideLiteEticomError] = useState("");

    const handleGlassDividersVerticalSideLiteEticomChange = (e) => {
        //setSelectedGlassDividersVerticalSideLiteEticom(e.target.value);
        validateGlassDividersVerticalSideLiteEticom(e.target.value);
        onChange(e.target.value);
    };
    const validateGlassDividersVerticalSideLiteEticom = (value) => {
        const numericValue = value.replace(/\D/g, ""); // Allow only numbers
        setSelectedGlassDividersVerticalSideLiteEticom(numericValue);
      
        if (numericValue && (numericValue < 0 || numericValue > 10)) {
            setGlassDividersVerticalSideLiteEticomError('must be between 0" and 10"');
        } else {
            setGlassDividersVerticalSideLiteEticomError("");
        }
    };
    return (
        <div className="a-container">
            <label style={{ display: "none" }} disabled={disabled} htmlFor="GlassDividersVerticalSideLiteEticom">{label}</label>
            <input style={{ display: "none" }}
                disabled={disabled}
                id="GlassDividersVerticalSideLiteEticom"
                value={selectedGlassDividersVerticalSideLiteEticom}
                onChange={handleGlassDividersVerticalSideLiteEticomChange}
            >
            </input>
            {GlassDividersVerticalSideLiteEticomError && <p className="error">{GlassDividersVerticalSideLiteEticomError}</p>}
        </div>
    );
};

export default GlassDividersVerticalSideLiteEticom;
